import { axiosPrivate } from '@/shared/api/axios'
import { API } from '@/shared/constants/api'
import type { AuditLogFilter, AuditLogQueryResult } from '../models/audit-log'

/** Consulta la bitácora central (`GET /audit`) con filtros opcionales. */
export async function getAuditLog(filter: AuditLogFilter): Promise<AuditLogQueryResult> {
  const { data } = await axiosPrivate.get<AuditLogQueryResult>(API.audit.root, {
    params: filter
  })
  return data
}
